import Head from 'next/head'
import ReviewScreen from '../screens/ReviewScreen'
import Script from 'next/script'

export default function Review() {
  return (
    <>
      <Head>
        <title>CollegePass - Account</title>
        <title>Success Stories | CollegePass</title>
        <meta
          name="description"
          content="The Ivy League, Oxbridge, Imperial College London: Explore success stories of CollegePass students admitted to Top Ranked Universities worldwide! "
        />
        <meta itemprop="name" content="Success Stories | CollegePass" />
        <meta
          itemprop="description"
          content="The Ivy League, Oxbridge, Imperial College London: Explore success stories of CollegePass students admitted to Top Ranked Universities worldwide!"
        />
        <meta
          itemprop="image"
          content="https://collegepass-event-banners.s3.ap-south-1.amazonaws.com/success_stories_banner_option7_rev.jpg"
        />
        <meta property="og:url" content="https://www.collegepass.org/terms" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Success Stories | CollegePass" />
        <meta
          property="og:description"
          content="The Ivy League, Oxbridge, Imperial College London: Explore success stories of CollegePass students admitted to Top Ranked Universities worldwide!"
        />
        <meta
          property="og:image"
          content="https://collegepass-event-banners.s3.ap-south-1.amazonaws.com/success_stories_banner_option7_rev.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Success Stories | CollegePass" />
        <meta
          name="twitter:description"
          content="The Ivy League, Oxbridge, Imperial College London: Explore success stories of CollegePass students admitted to Top Ranked Universities worldwide!"
        />
        <meta
          name="twitter:image"
          content="https://collegepass-event-banners.s3.ap-south-1.amazonaws.com/success_stories_banner_option7_rev.jpg"
        />
        <link rel="canonical" href="https://www.collegepass.org/success-stories" />
        <Script TYPE="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": "CollegePass Reviews: Haydr's Ivy League Success Story",
          "description": "Haydr started his College Admissions Journey with CollegePass in 2020 and has been admitted to 'The Ivy League'.
          Haydr will start his Ivy League Journey as a freshman at The University of Pennsylvania in September 2022!
          Aiden has been awarded a USD160,000 Scholarship by UPenn!",
          "thumbnailUrl": "https://www.collegepass.org/_next/image?url=%2FVerticle-success-stories%2Faiden_dutta.png&w=750&q=75",
          "uploadDate": "2024-01-30",
          "duration": "PT4M59S",
          "embedUrl": "https://player.vimeo.com/video/671414452?h=09f6c79088"
        }
        `}
        </Script>
        <Script TYPE="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": "CollegePass Reviews: Anishka Shares Her Experience and Advice for Year 11 & 12",
          "description": "Anishka of the High School Class of 2021 shares her CollegePass Experience and advice to Incoming Year 11 and 12.",
          "thumbnailUrl": "https://www.collegepass.org/_next/image?url=%2FVerticle-success-stories%2Fanishka_bompelli.png&w=750&q=75",
          "uploadDate": "2022-06-22",
          "duration": "PT6M7S",
          "embedUrl": "https://player.vimeo.com/video/535852056"
        }
        `}
        </Script>
        <Script TYPE="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": "CollegePass Reviews: How Khushi Got Admitted to Top UK and US Universities",
          "description": "Khushi started working with CollegePass Team in 2020 and has been admitted to the University of Warwick, UC Davis, University of Manchester, University College London, King's College London & UCLA.",
          "thumbnailUrl": "https://www.collegepass.org/_next/image?url=%2FVerticle-success-stories%2Fkhushi_sampat.png&w=750&q=75",
          "uploadDate": "2022-06-22",
          "duration": "PT2M43S",
          "embedUrl": "https://player.vimeo.com/video/573945142"
        }
        `}
        </Script>
        <Script TYPE="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": "CollegePass Reviews: Niraj’s Success with NYU (New York University) and Pace University",
          "description": "Niraj started working with CollegePass in 2019 and has received offers from Top Universities like New York University (USD 45000 Scholarship) and Pace University (USD 70000 Scholarship).",
          "thumbnailUrl": "https://www.collegepass.org/_next/image?url=%2FVerticle-success-stories%2Fneeraj_nair.png&w=750&q=75",
          "uploadDate": "2024-04-22",
          "duration": "PT2M50S",
          "embedUrl": "https://player.vimeo.com/video/520822820"
        }
        `}
        </Script>
        <Script TYPE="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": "CollegePass Reviews: How Pratibha’s Son Niraj Got into New York University",
          "description": "Pratibha's son Niraj started working with CollegePass in 2019 and has been admitted to his dream college: New York University.",
          "thumbnailUrl": "https://www.collegepass.org/_next/image?url=%2FVerticle-success-stories%2Fpratibha_nair.png&w=750&q=75",
          "uploadDate": "2022-06-22",
          "duration": "PT5M16S",
          "embedUrl": "https://player.vimeo.com/video/541041438"
        }
        `}
        </Script>
        <Script TYPE="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": "CollegePass Reviews: Sheeja Shares Tulsi’s Journey to Her Dream College",
          "description": "Sheeja shares the CollegePass experience of her daughter Tulsi who has been successfully admitted to her dream college.",
          "thumbnailUrl": "https://www.collegepass.org/_next/image?url=%2FVerticle-success-stories%2Fsheeja_cassius.png&w=750&q=75",
          "uploadDate": "2023-07-27",
          "duration": "PT1M50S",
          "embedUrl": "https://player.vimeo.com/video/507858570"
        }
        `}
        </Script>
        <Script TYPE="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": "CollegePass Reviews: Anuj’s Son Varun’s Journey to Northeastern University",
          "description": "Anuj's son Varun Jhamvar teamed up with CollegePass Admission Experts and is now studying Economics at Northeastern University. Varun also got admitted to the University of California - Davis, University of Massachusetts - Amherst and Boston University.",
          "thumbnailUrl": "https://www.collegepass.org/_next/image?url=%2FVerticle-success-stories%2FAnuj.png&w=750&q=75",
          "uploadDate": "2024-04-17",
          "duration": "PT4M1S",
          "embedUrl": "https://player.vimeo.com/video/878549358"
        }
        `}
        </Script>
        <Script TYPE="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": "CollegePass Reviews: Pankhuri’s Journey to Stanford and Tips for Future Applicants",
          "description": "CollegePass Student Pankhuri talks about her journey to stanford, tips for future applicants and the CollegePass Experience!",
          "thumbnailUrl": "https://www.collegepass.org/_next/image?url=%2FVerticle-success-stories%2Fpankhuri.png&w=750&q=75",
          "uploadDate": "2022-09-21",
          "duration": "PT3M58S",
          "embedUrl": "https://player.vimeo.com/video/689536463"
        }
        `}
        </Script>
        <Script TYPE="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": "CollegePass Reviews: Nitin’s Son Sahil’s Success with 13 College Offers",
          "description": "Nitin's son Sahil began his college preparation journey with CollegePass in 2019. 
        
          He has received multiple admission offers (13) from his target US, & Canadian Universities: University of Washington, Seattle, Texas A&M, UT Dallas, University of Alberta, York, and University of Toronto.",
          "thumbnailUrl": "https://www.collegepass.org/_next/image?url=%2FVerticle-success-stories%2Fnitin.png&w=750&q=75",
          "uploadDate": "2023-06-23",
          "duration": "PT3M8S",
          "embedUrl": "https://player.vimeo.com/video/832583466"
        }
        `}
        </Script>
      </Head>

      <main className="bg-black">
        <ReviewScreen></ReviewScreen>
      </main>
    </>
  )
}
